import React, { useMemo, useState, useEffect } from 'react'
import qs from 'qs'
import { useNavigate } from 'react-router-dom'
import { hasAuth as authHasAuth } from 'meinian-package/src/utils/auth'
import AuthorityIntroduced from 'meinian-package/src/component/authorityIntroduced'
import Tooltip from 'meinian-package/src/baseComponent/tooltip'
import Button from 'meinian-package/src/baseComponent/button'
import { Icon, CreateOrEditChildIdeaMass } from 'meinian-package/src/component'
import Pro2 from 'image/detail/pro2.png'
import freeze from 'image/detail/freeze.png'
import classNames from 'classnames'
import * as userAuth from 'meinian-package/src/utils/auth'
import { EditIdeaMass, Share, Sharing } from 'component'
import { QuickAccess, } from 'baseComponent'
import FirstTooltip from 'meinian-package/src/component/firstTooltip'
import emitter from 'meinian-package/src/utils/emitter'
import { EmitterEvents, TAB, TIP_KEYS } from '../enum'
import ChildInspiration from '../childInspiration'
import { SwitchPageTabContent } from '../../../components/switchTab'
import ChooseTaskDrawer from '../chooseTaskDrawer'
import MoreInspirationFIlter from './moreInspirationFIlter'
import FilterRight from './operation'
import MoreOperation from './moreOperation'
import { useInspirationContext } from '../inspirationTree.context'
import PastDrawerBtn from '../pastDrawer'
import styles from './index.module.less'

const useCooperationMember = () => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  const history = useNavigate()
  const inspirationTree = useInspirationContext()
  const onDelete = () => {
    if (query.parentId) {
      const parentNode = inspirationTree.findNodeByValue(query.parentId)
      const curItem = parentNode.current
      if (curItem?.parent) {
        history(`/home/coll/detail/${curItem.id}?inspirationId=${curItem.id}&parentId=${curItem.parent.value}&name=${curItem.name}`)
        return
      }
      history(`/home/coll/detail/${curItem.id}?inspirationId=${curItem.id}`)
    } else {
      history('/home')
    }
  }
  return {
    onDelete
  }
}

export const CooperationMember = ({ auth, info, onInit, text = '协作成员', onClick }) => {
  const { onDelete } = useCooperationMember()
  return <EditIdeaMass
    currentRole={info?.loginUserInfo?.role}
    auth={auth}
    inspirationId={info.id}
    mode={2}
    onChange={() => onInit()}
    onDelete={() => {
      onDelete()
    }}
  >
    <Button onClick={onClick} style={{ marginLeft: '8px' }}>{text}</Button>
  </EditIdeaMass>
}

const ChildCooperationMember = ({ auth, info, onInit }) => {
  const { onDelete } = useCooperationMember()
  return <CreateOrEditChildIdeaMass
    isCreate={false}
    auth={auth}
    currentRole={info?.loginUserInfo?.role}
    inspirationId={info.id}
    onChange={() => onInit()}
    onDelete={() => {
      onDelete()
    }}
  >
    <Button style={{ marginLeft: '8px' }}>协作成员</Button>
  </CreateOrEditChildIdeaMass>
}
// 101-秀场直击，102-社媒潮流(小红书)，103-社媒潮流(INS)
const PAST_KEYS = [101, 102, 103]
const PAST_KEYS_VALUES = {
  101: ['runway', '秀场直击'],
  102: ['social', '社媒潮流'],
  103: ['social', '社媒潮流']
}

export default ({
  guides,
  info,
  isFreezeFun,
  auth,
  onInit,
  tabValue,
  onTabChange,
  setBatchValue,
  params,
  teamInfo,
  fetchInfo,
  setInfo,
  subColls,
  hasFilter,
  setHasFilter,
  styleFilterCount,
  tabMoveInspirationParams,
  setTabMoveInspirationParams,
  defaultParams,
  setParams,
  setStyleFilterCount,
  total,
  cooperationTipHidden,
  onCooperationTipClose,
}) => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  const isPro = info.isPro === 1
  const isChild = info.parentId && info.parentId !== -1

  const _tabOption = useMemo(() => {
    const TAB_OPTION = [
      { label: '款式', value: TAB.ALL, auth: true, num: total, },
      { label: '分析', value: TAB.DATA_ANALYSIS, auth: auth.includes('F12') && !query.parentId },
      { label: '更多灵感', value: TAB.OFFICIAL_INSPIRATION, auth: (authHasAuth('dl_monitor_center') || authHasAuth('dl_ins')) && !query.shareUrl },
    ]
    return TAB_OPTION
  }, [total, auth, guides])

  const [chooseDrawerVisible, setChooseDrawerVisible] = useState(false)

  useEffect(() => {
    if (query.messageType === '1' && query.messageRule === 'selectionTask') {
      setChooseDrawerVisible(true)
    }
  }, [])

  const renderActionDom = () => {
    if (!userAuth.isPermissions(auth, ['FC07', 'F06'])) {
      return null
    }
    if (isChild) {
      return <ChildCooperationMember onInit={fetchInfo} info={info} auth={auth} />
    }
    return <FirstTooltip
      text="邀请同事一起协作采集、选款"
      visible={cooperationTipHidden}
      placement="bottomRight"
      onClose={() => {
        onCooperationTipClose()
      }}
      getPopupContainer={() => document.querySelector('.meinian-detail-coll')}
    >
      <CooperationMember
        onClick={() => {
          if (cooperationTipHidden) {
            onCooperationTipClose()
          }
        }}
        onInit={fetchInfo}
        info={info}
        auth={auth}
      />
    </FirstTooltip>
  }

  return <div className={styles['coll-info-wrap']}>
    {chooseDrawerVisible && <ChooseTaskDrawer auth={auth} info={info} visible={chooseDrawerVisible} onClose={() => setChooseDrawerVisible(false)} />}
    <div style={{ padding: '20px 24px 16px 24px' }}>
      {
     isFreezeFun(info.freezeStatus) && <div className="info-wrap-freeze">
       <img src={freeze} />
     </div>
    }
      <div className="coll-info-wrap-header">
        <div className="coll-info-wrap-header-title">
          <div className={classNames('info-title', { disabled: isFreezeFun(info.freezeStatus) })}>
            {info.name}
            {isPro && <img src={Pro2} /> }
            {
              PAST_KEYS.some(item => info.officialType === item) && <PastDrawerBtn
                title={PAST_KEYS_VALUES[info?.officialType]?.[1]}
                queryType={PAST_KEYS_VALUES[info?.officialType]?.[0]}
              />
            }
            {
              info.reportKey && <Button
                type="normal"
                style={{ padding: '2px 8px', marginLeft: '8px', fontSize: '14px', fontWeight: 400 }}
                onClick={() => window.open(`/report/preview?id=${info.reportKey}`)}
              >相关报告<Icon type="m-Vxing_you" /></Button>
            }
          </div>
        </div>
        <div className="coll-info-wrap-header-right">
          {
            userAuth.hasInspirationAuth(isChild, auth, ['F02', 'FC03']) && <MoreOperation
              teamInfo={teamInfo}
              fetchInfo={fetchInfo}
              setInfo={setInfo}
              onInit={onInit}
              auth={auth}
              info={info}
              isFreezeFun={isFreezeFun}
              setChooseDrawerVisible={setChooseDrawerVisible}
            />
          }
          {userAuth.isPermissions(auth, ['FC10', 'F09', 'F02', 'FC03']) && userAuth.teamHasAuth('meinian_share_inspiration') ? <FirstTooltip
            text="分享你的灵感集，传递灵感给伙伴吧"
            visible={guides[TIP_KEYS[3]]}
            placement="bottom"
            onClose={() => {
              emitter.emit(EmitterEvents.TIP_KEYS, TIP_KEYS[3])
            }}
            getPopupContainer={() => document.querySelector('.meinian-detail-coll')}
          ><div
            className={styles['more-operation']}
            style={{ margin: '0 8px' }}
            onClick={() => {
              if (guides[TIP_KEYS[3]]) {
                emitter.emit(EmitterEvents.TIP_KEYS, TIP_KEYS[3])
              }
              (info.shareStatus ? Sharing.show({
                isChild,
                inspirationId: info.id,
                name: info.name,
                cooperation: info.cooperation,
                auth,
                onChange: fetchInfo })
                : Share.show({ auth, isChild, inspirationId: info.id, name: info.name, cooperation: info.cooperation, onChange: fetchInfo }))
            }}
          >
            <Icon style={{ fontSize: 20, verticalAlign: 'top' }} type={info.shareStatus ? 'm-fenxiang' : 'm-fenxiang'} />
          </div>
          </FirstTooltip> : null}
          {
              userAuth.hasInspirationAuth(isChild, auth, ['F02', 'FC03']) && <FirstTooltip
                text="添加至快速访问，不费力就能找到"
                visible={guides[TIP_KEYS[4]]}
                onClose={() => {
                  emitter.emit(EmitterEvents.TIP_KEYS, TIP_KEYS[4])
                }}
                getPopupContainer={() => document.querySelector('.meinian-detail-coll')}
              ><QuickAccess
                isQuickAccess={info?.isQuickAccess}
                id={info?.id}
                name={info?.name}
                onChange={(_, { isQuickAccess }) => {
                  info.isQuickAccess = isQuickAccess
                  setInfo(pre => ({ ...pre }))
                }}
              >
                <div
                  className={styles['more-operation']}
                  onClick={() => {
                    if (guides[TIP_KEYS[4]]) {
                      emitter.emit(EmitterEvents.TIP_KEYS, TIP_KEYS[4])
                    }
                  }}
                >
                  <Icon style={{ fontSize: 20, verticalAlign: 'top' }} type={info?.isQuickAccess ? 'm-quxiaokuaisufangwen' : 'm-kuaisufangwen'} />
                </div>
              </QuickAccess>
              </FirstTooltip>
            }
          {
            !query.shareUrl && <ChildInspiration
              data={subColls}
              info={info}
              query={{ tab: TAB.ALL, shareUrl: query.shareUrl }}
              crateInspirationAuth={auth.includes('FC01')}
            />
          }
          {
            renderActionDom()
          }
        </div>
      </div>
      <div className="info-cooperation-container">
        <img src={info?.ownerAvatar} alt="" />
        <span className="info-creator-name">{info?.ownerName}</span>
        {
        auth.includes('F06')
          ? <AuthorityIntroduced
              currentRole={info?.loginUserInfo?.role}
          >
            <Tooltip title="权限说明">
              <Icon
                style={{
                  marginLeft: 4,
                  verticalAlign: 'text-bottom',
                  fontSize: 16,
                  color: 'var(--m-text-3)',
                  cursor: 'pointer'
                }}
                type="m-xinxi_miaobian"
              />
            </Tooltip>
          </AuthorityIntroduced>
          : null
    }
      </div>
    </div>
    <div className="coll-info-wrap-tab-content">
      <SwitchPageTabContent
        className="coll-info-wrap-tab"
        value={tabValue}
        options={_tabOption.filter(i => i.auth)}
        onChange={(val) => {
          onTabChange(val)
          setHasFilter(false)
        }}
      />
      {
        tabValue === TAB.ALL && <FilterRight
          params={params}
          auth={auth}
          isChild={isChild}
          fetchInfo={fetchInfo}
          onChange={(val) => {
            setBatchValue(val)
            setHasFilter(false)
          }}
          info={info}
          hasFilter={hasFilter}
          setBatchValue={setBatchValue}
          styleFilterCount={styleFilterCount}
          setHasFilter={setHasFilter}
          defaultParams={defaultParams}
          setParams={setParams}
          setStyleFilterCount={setStyleFilterCount}
        />
      }
      {
        tabValue === TAB.OFFICIAL_INSPIRATION && <MoreInspirationFIlter
          tabMoveInspirationParams={tabMoveInspirationParams}
          setTabMoveInspirationParams={setTabMoveInspirationParams}
        />
      }
    </div>
  </div>
}
